export type ProjectionScenarioInput = {
  initialStock: number
  averageWeightG: number
  dailyMortalityRatePct: number | null
  daysToProject: number
}

export type ProjectionScenarioResult = {
  projectedStock: number | null
  projectedBiomassKg: number | null
}

export const projectStockByDailyMortalityRate = (args: {
  initialStock: number
  dailyMortalityRatePct: number
  daysToProject: number
}): number | null => {
  const { initialStock, dailyMortalityRatePct, daysToProject } = args
  if (!Number.isFinite(initialStock) || initialStock <= 0) return null
  if (!Number.isFinite(dailyMortalityRatePct) || dailyMortalityRatePct < 0) return null

  const safeDays = Math.max(1, Math.floor(daysToProject))
  let projectedStock = initialStock

  for (let dayIndex = 0; dayIndex < safeDays; dayIndex += 1) {
    const projectedMortalityCount = Math.round((projectedStock * dailyMortalityRatePct) / 100)
    projectedStock = Math.max(0, projectedStock - projectedMortalityCount)
  }

  return projectedStock
}

export const deriveCurrentTrendProjectionScenario = (input: ProjectionScenarioInput): ProjectionScenarioResult => {
  if (input.dailyMortalityRatePct === null) {
    return {
      projectedStock: null,
      projectedBiomassKg: null
    }
  }

  const projectedStock = projectStockByDailyMortalityRate({
    initialStock: input.initialStock,
    dailyMortalityRatePct: input.dailyMortalityRatePct,
    daysToProject: input.daysToProject
  })

  if (projectedStock === null || !Number.isFinite(input.averageWeightG) || input.averageWeightG < 0) {
    return {
      projectedStock,
      projectedBiomassKg: null
    }
  }

  return {
    projectedStock,
    projectedBiomassKg: (projectedStock * input.averageWeightG) / 1000
  }
}
